import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Profile from "./Profile";

const styles = {
    inlineBlock: { display: "inline-flex", marginRight: "1rem" }
};

// export const UserEdit = withStyles(styles)(({ classes, ...props }) => (
export default withStyles(styles)(({ permissions, classes, ...props }) => (
    <Profile {...this.props} />
));



// WEBPACK FOOTER //
// ./src/components/ShowProfile.js